import { Pipe, PipeTransform } from '@angular/core';
import { GalleryStatus } from '@picflow/types';

export const getGalleryStatusColor = (status: GalleryStatus): string => {
  if (status === 'approved') return 'green';
  if (status === 'no_status') return 'grey-50';
  if (status === 'progress') return 'blue';
  if (status === 'review') return 'orange';
  if (status === 'revisions') return 'warn';
};

@Pipe({
  name: 'galleryStatusColor',
  standalone: true,
})
export class GalleryStatusColorPipe implements PipeTransform {
  transform(status: GalleryStatus): string {
    return getGalleryStatusColor(status);
  }
}
